import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router";
import PaymentModal from "../Modals/PaymentModal";
import {createOrder, createVivaOrder, fetchTaxRates, get_cfg, validateOrder} from "../api/apis";
import SwishModal from "../Modals/SwishModal";
import { useApp } from "../Context";
import BottomSheet from "../components/BottomSheet";
import PaymentOptions from "../components/PaymentOptions";
import { fetchCart } from "../util/PurchaseManager";

export default function CheckoutPage() {
    const [cart, setCart] = useState([]);
    const [total, setTotal] = useState(0);
    const navigate = useNavigate();
    const VAT_RATE = 0.12; // 12% MOMS
    const [orderId, setOrderId] = useState(null);
    const [swish, setSwish] = useState(false)
    const [instructions, setInstructions] = useState("")
    const {getCfg, table, init, sid, orderids, setOrderids} = useApp()
    const [discount, setDiscount] = useState(0)
    const {restaurant} = useParams()



    const [payment, setPayment] = useState(null);
    const [tip, setTip] = useState(0);
    const [customTip, setCustomTip] = useState(false);

    const [error, setError] = useState(null)

    const applyTip = ({ rate = 0, amount = 0 }) => {
        const base = total - discount;
        const calculatedTip = base * rate / 100 + amount;
        setTip(calculatedTip);
    };


    const [toPay, setToPay] = useState(total+tip-discount)


    useEffect(()=>{
        init()
        setToPay(total+tip-discount)
    },[total, tip, discount])


    const tips = [5,10,20]


    useEffect(() => {
        const storedCart = fetchCart(sid)

        setCart(storedCart.items);
        setTotal(storedCart.sum);
        setInstructions(storedCart.instructions || "");

        if (storedCart.discount) {
        const voucher = storedCart.discount;
        const [key, value] = Object.entries(voucher)[0]; // fix: access first entry directly;

        const discount = parseFloat((storedCart.sum * (value / 100)).toFixed(2));
        setDiscount(discount);

        }

    }, []);

    const { setCfg, cfg: contextCfg } = useApp(); // include current cfg

    useEffect(() => {
    (async () => {
        const freshCfg = await get_cfg(restaurant);
        if (!freshCfg) return;

        // ⬅ Merge in current `bord` and any other critical local values
        const merged = {
        ...freshCfg,
        bord: contextCfg?.bord,
        flow: contextCfg?.flow,
        nocart: contextCfg?.nocart
        };

        setCfg(merged);
    })();
    }, []);




    const vatAmount = toPay * VAT_RATE;
    const totalExclVAT = toPay - vatAmount;

    const TipModal = () => {
        const [tip, setTip] = useState(null);
        return(
            <BottomSheet showModal={customTip} setShowModal={setCustomTip} headerText="Ange dricksbelopp" saveText="Bekräfta" saveAction={()=>{applyTip({amount: parseFloat(tip)})}} showCancel={true}>
                <label>Dricks</label>
                <div className="d-flex gap-2 align-items-center ">
                    <input
                    className="form-control bg-light"
                    value={tip}
                    onChange={(e)=>{setTip(e.target.value)}}
                    placeholder="0.00"
                    type="number"
                    />
                    <span>SEK</span>
                </div>
            </BottomSheet>
        )
    }

    function handleOrder() {
      console.log(orderId)
        if(!orderId) {
            payWithSwish().then((response) => {
                setOrderId(response);
            })
        }
        setSwish(true)
    }

    function handleViva(){
        if(!orderId) {
            payWithSwish().then((response) => {
                console.log(response)
                setOrderId(response);
                createVivaOrder(response);
            })
        }else{
            createVivaOrder(orderId);
        }

    }

    return (
        <div className="px-1 mt-5">
            {/* Back Button */}
            <div className="d-flex align-items-center" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                <i className="bi bi-arrow-left-short fs-1"></i>
                <h5 className="mb-0">Tillbaka</h5>
            </div>

            <h2 className="text-center fw-bold text-dark mb-4">Kassa</h2>

            {cart.length === 0 ? (
                <p className="text-center text-muted">Din varukorg är tom.</p>
            ) : (
                <div className="row">
                    {/* Order Summary */}
                    <div className="">
                    <div className="card shadow-sm p-3">
    <h4 className="fw-bold">Orderöversikt</h4>
    <hr className="my-2"/>

    {cart.map((item, index) => (
  <div key={index} className="mb-3">
    {/* Main Item */}
    <div className="d-flex justify-content-between">
      <span className="fw-bold text-dark">{item.text.toSwe()}</span>
      <span className="fw-bold">{(item.price / 100).toFixed(2)} SEK</span>
    </div>


    {/* Specialbeställning */}

    {/* Lägg till (Add-ons) */}
    {item.customizations?.addons?.length > 0 && (
      <div className="mt-1 ps-3">
        {item.customizations.addons.map((a, i) => (
          <div key={i} className="d-flex justify-content-between">
            <span className="text-muted">{a.label}</span>
            <span className="text-muted">
              {a.price.toFixed(2)} SEK
            </span>
          </div>
        ))}
      </div>
    )}

    {/* Sides */}
    {item.customizations?.sides?.length > 0 && (
      <div className="mt-1 ps-3">
        {item.customizations.sides.map((s, i) => (
          <div key={i} className="d-flex justify-content-between">
            <span className="text-muted">{s.label}</span>
            <span className="text-muted">
              {s.price.toFixed(2)} SEK
            </span>
          </div>
        ))}
      </div>
    )}

    {/* Comment */}

  </div>
))}

    {discount > 0 && (
  <>
  <hr className="m-1"/>
    {(() => {
      return (
        <div className="d-flex justify-content-between fw-bold text-success">
          <span>Rabatt</span>
          <span>{`-${discount} SEK`}</span>
        </div>
      );
    })()}
  </>
)}

    </div>
                    </div>

                    {/* Payment & Total Summary */}
                    <div className=" mt-2">
                        <div className="card shadow-sm p-3 bg-white">
                            <h5 className="fw-bold text-dark">Betalningsinformation</h5>
                            <div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Delsumma:</span>
                                    <span className="fw-bold">
                                        {(toPay - vatAmount).toFixed(2)} SEK
                                    </span>

                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">MOMS (12%):</span>
                                    <span className="fw-bold">{(toPay * VAT_RATE).toFixed(2)} SEK</span>
                                </div>
                            </div>
                            <hr />
                            {/*
                            {tip > 0 ?
                            <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-bold fs-6 d-flex align-items-center gap-1">
                              Dricks:
                              <button
                                className="btn btn-sm btn-outline-secondary p-1"
                                style={{ lineHeight: 1 }}
                                onClick={()=>{setTip(0)}}
                              >
                                <i className="bi bi-pencil-square" style={{ fontSize: "14px" }}></i>
                              </button>
                            </span>
                            <span className="fw-bold">
                              {tip.toFixed(2) + " SEK"}
                            </span>
                          </div>
                            :
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="fw-bold fs-6">Dricks</span>
                                        <span className="text-muted">(valfritt)</span>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2">
                                         {tips.map((item, index)=>
                                            <button key={index} className="btn btn-outline-primary rounded-pill px-4" onClick={()=>{applyTip({rate: item})}}>
                                                {`${item}%`}
                                            </button>
                                        )}
                                        <button className="btn btn-outline-secondary rounded-pill px-3" onClick={()=>{setCustomTip(true)}}>
                                            <i className="bi bi-pencil"></i> Belopp
                                        </button>
                                    </div>
                                </div>
                                }

                                <hr />
                                */}

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold fs-5">Total:</span>
                                <span className="fw-bold fs-5">{(toPay).toFixed(2)} SEK</span>
                            </div>

                            {/* Payment Options */}
                            <PaymentOptions handle1={handleOrder} handle2={handleViva}/>
                        </div>
                        <PaymentModal method={payment} setMethod={setPayment} />
                        <SwishModal order={orderId} sum={toPay} show={swish} setShow={setSwish} />
                        <TipModal/>
                        <ErrorModal/>
                    </div>
                </div>
            )}
        </div>
    );

    async function payWithSwish() {
  const cfg = await getCfg();

  // Add expected config defaults
  cfg.flow = "eatin";
  cfg.ftid = cfg.hours?.ftid || "1500";
  cfg.ttid = cfg.hours?.ttid || "2300";
  cfg.nocart = 1;

  // Fetch tax rates first
  const taxRes = await fetchTaxRates();
  const taxRates = taxRes.ok ? taxRes.taxRates : {};

  // Transform all cart items
  const transformedCart = await Promise.all(cart.map(item => transformItem(item, taxRates)));

  const cartPro = Object.fromEntries(
    transformedCart.map((item, index) => [index.toString(), item])
  );

  const sbo = {
    sio: null,
    cfg: cfg,
    unit: {},
    msg: instructions || "",
    cdo: {
      msg: instructions || ""
    },
    cart: {
      bord: table,
      zone: "",
      belopp: (toPay * 100).toFixed(),
      rows: transformedCart,
      // pro: cartPro,
      levbelopp: (tip * 100).toString(),
      discount: (discount * 100).toString(),
      slot: `${(new Date()).getHours()}00`
    }
  };

  const res = await validateOrder(sbo);
  if (res.ok) {
    console.log(sbo);
    const orderid = await createOrder(sbo);
    const orders = orderids
    orders.push({id: orderid, paid: false})
    setOrderids(orders)
    return orderid
  } else {
    setError(res.error);
  }
}

    async function transformItem(item, taxRates) {
  function getIno(item) {
    const ino = {};
    item.customizations?.removed?.forEach(ing => {
      ino[ing.id] = {
        plu: ing.id,
        p0text: ing.label,
        text: ing.label,
        price: "0"
      };
    });
    return ino;
  }

  function getTxo(item) {
    const txo = {};
    item.customizations?.addons?.forEach(addon => {
      txo[addon.id] = {
        m0katnr: addon.id,
        m0text: addon.label,
        m0pris: (addon.price || 0).toString(),
        m0nrof: "1",
        taxproc: taxRates[taxKey]
      };
    });
    return txo;
  }

  function getSxo(item) {
    console.log(item)
    const sxo = {};
    item.customizations?.sides?.forEach(side => {
      sxo[side.id] = {
        m0katnr: side.id,
        m0text: side.label,
        m0pris: (side.price || 0).toString(),
        m0nrof: "1",
        taxproc: taxRates[taxKey]
      };
    });
    return sxo;
  }

  const comment = [
    ...Object.values(item.customizations?.steps || {}).map(s => s.label),
    ...(item.customizations?.special || []).map(s => s.label),
    (item.customizations?.comment || "").trim()
  ].filter(Boolean).join(', ');

  const price = item.price?.toString() || "0";
  const finalPrice = item.finalPrice?.toString() || price;
  const taxKey = item.pbo.plu00.p0moms;
  const taxproc = taxRates[taxKey] || "2000";

  const base = {
    plu: item.plu,
    text: item.text,
    mnuid: item.mnuid,
    price,
    desc: item.desc || "",
    belopp: finalPrice,
    antal: "1",
    taxproc,
    comment,
    ino: getIno(item),
    ixo: {},
    txo: getTxo(item),
    sxo: getSxo(item),
    dxo: {}
  };

  return {
    ...base,
    pro: { ...base }
  };
}


    function ErrorModal(){

      return<BottomSheet showModal={error} setShowModal={setError} showFooter={false} headerText="Felaktig order">
        <p>{error}</p>
      </BottomSheet>
    }

    }
